// extracted by mini-css-extract-plugin
module.exports = {"customBackgroundWrapper":"style_customBackgroundWrapper__nB0nO"};